interface CanyonSidebarProps {
  currentPage: string;
  onPageChange: (page: string) => void;
  user: any;
  onLogout: () => void;
}

export const CanyonSidebar = ({ currentPage, onPageChange, user, onLogout }: CanyonSidebarProps) => {
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: '🏠' },
    { id: 'create-quote', label: 'Create Quote', icon: '➕' },
    { id: 'quotes', label: 'Quotes', icon: '💬' },
    { id: 'insights', label: 'Insights', icon: '💡' },
  ];

  return (
    <div className="sidebar">
      <div className="sidebar-header">
        <h2>🏔️ Canyon</h2>
      </div>
      
      <div className="user-profile">
        {user.picture && <img src={user.picture} alt="Profile" className="profile-pic" />}
        <div className="user-name">{user.name}</div>
        <div className="user-email">{user.email}</div>
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) => (
          <button
            key={item.id}
            className={`nav-item ${currentPage === item.id ? 'active' : ''}`}
            onClick={() => onPageChange(item.id)}
          >
            <span className="nav-icon">{item.icon}</span>
            <span className="nav-label">{item.label}</span>
          </button>
        ))}
      </nav>

      <div className="sidebar-footer">
        <button onClick={onLogout} className="logout-button">
          Sign Out
        </button>
      </div>
    </div>
  );
};